import { z } from 'zod'

const envSchema = z.object({
  VITE_CONVEX_URL: z.string().min(1, 'VITE_CONVEX_URL is required'),
  VITE_CONVEX_SITE_URL: z.url().min(1, 'VITE_CONVEX_SITE_URL is required'),
  VITE_SENTRY_DSN: z.url().optional(),
  VITE_WORKOS_CLIENT_ID: z.string().min(1, 'VITE_WORKOS_CLIENT_ID is required'),
  VITE_WORKOS_REDIRECT_URI: z.string().min(1, 'VITE_WORKOS_REDIRECT_URI is required'),
  VITE_SYNCFUSION_SERVICE_URL: z.string().url().min(1, 'VITE_SYNCFUSION_SERVICE_URL is required'),
  VITE_SYNCFUSION_USERNAME: z.string().optional(),
  VITE_SYNCFUSION_PASSWORD: z.string().optional(),
})

const _env = envSchema.safeParse(import.meta.env)

if (!_env.success) {
  const errorMessages = _env.error.issues.map(
    (issue) => `${issue.path.join('.')}: ${issue.message}`,
  )

  console.error('Environment Variable Failures:', errorMessages)

  throw new Error('Check console for invalid environment variables.')
}

export const env = _env.data
